const isLive = () => {
  if (window.location.hostname === "www.rizevo.com" || window.location.hostname === "app.kindlybook.com") {
    return true;
  }
  return false;
};

export default isLive;
